var map = {
	"./collage-0.webp": 19404,
	"./collage-1.webp": 69670,
	"./collage-1029w-0.webp": 26851,
	"./collage-2.webp": 33864,
	"./collage-3.webp": 65447,
	"./collage-4.webp": 73311,
	"./collage-503w-2.webp": 92442,
	"./collage-503w-4.webp": 83835
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31100;